/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__add = () => `Add`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back = () => `Back`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = () => `Back to homepage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = () => `Back to overview`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_to_search = () => `Back to search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = () => `Close panel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__delete = () => `Delete`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__edit = () => `Edit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__modify = () => `Edit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = () => `Open the panel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__print = () => `Print`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = () => `Retry`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save = () => `Save`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_in = () => `Sign in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = () => `Sign up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = () => `Confirm`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__article_button = () => `Read more`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__badge_text = () => `Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = () => `Travel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = () => `Our must-see destinations and all our travel inspirations are in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = () => `Discover`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = () => `Check out our travel tips and let the Magazine guide you`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = () => `Need inspiration?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__second_line = () => `ViaMichelin Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = () => `We are unable to obtain the information.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = () => `Place not found`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alert_itinerary__closed_roads__cta = () => `Bypass`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__close_button__label = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = () => `There are currently no alerts in the selected zone.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = () => `To view alerts, enter a location in the search box.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = () => `Add this route to my favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_car = () => `Car`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_caravan = () => `Caravan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_electricCar = () => `Electric car`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = () => `Motorcycle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__delete_favorite_ariaLabel = () => `Delete route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite__routes = () => `Favourite routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = () => `You have reached the maximum number of favourite routes you can save.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = () => `See your favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = () => `Find my favourite routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = () => `Route removed from your favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = () => `This route couldn't be added to your favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = () => `Please try again`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = () => `Saved itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = () => `Route added to favorites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = () => `No routes saved in your favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = () => `Save your favourite routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see = () => `See my favourites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see_favorite_route = () => `See the route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = () => `Actions (Delete or view route)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = () => `Route details (start, finish, stages)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__via = () => `Via`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = () => `Arrival`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = () => `Select an arrival date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = () => `Delete`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = () => `Confirm`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = () => `Arrival date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = () => `Delete selected dates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = () => `Departure`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = () => `night`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = () => `nights`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = () => `Select start and end date using the calendar widget`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = () => `return to the homepage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__or = () => `or`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = () => `if you can't find what you're looking for.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = () => `You can`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__title = () => `This page has been removed or modified`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = () => `for assistance.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = () => `Our team is currently working to solve the problem. You can try again later or`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = () => `This page couldn’t be loaded`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = () => `contact us`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (params) => `${params.count} spots`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = () => `1 spot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const favoriteItineraries__deleteError = () => `This route could not be removed from favorites`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = () => `Frequently asked questions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = () => `Browse ViaMichelin Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = () => `Subscribe to our Newsletter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B10 = () => `Diesel Premium`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B7 = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__CNG = () => `Biomethane`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E10 = () => `SP 95 - E10`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5 = () => `SP 95`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5_98 = () => `SP 98`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E85 = () => `Ethanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__H2 = () => `H2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__LPG = () => `GPL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const highways = () => `Motorways`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = () => `Clear input`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (params) => `Your route in ${params.count} s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = () => `Add a step`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__compute = () => `Search for an itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = () => `Your current location`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__edit = () => `Edit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = () => `Invert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = () => `Maximum number of steps reached`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__edit = () => `Edit your vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = () => `Add your vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__user = () => `My vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__bifuel = () => `Bifuel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__cng = () => `CNG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__diesel = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__electric = () => `Electric`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__ethanol = () => `Ethanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = () => `Gasoline`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hybrid = () => `Hybrid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hydrogen = () => `Hydrogen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__lpg = () => `LPG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__city = () => `City`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__compact = () => `Compact`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__saloon = () => `Saloon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__sports = () => `Sports`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__suv = () => `SUV`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle = () => `You are travelling with a caravan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = () => `Adapts cost, journey time and consumption data but not the route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__error = () => `The vehicles couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__retry = () => `Retry`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_border_crossing = () => `Avoid border crossings`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_ferry = () => `Avoid ferries`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_low_emission_zone = () => `Avoid low emission zones`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_motorway = () => `Avoid motorways`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_toll = () => `Avoid tolls`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = () => `Avoid toll vignettes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__none = () => `None`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency = () => `Currency`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__chf = () => `CHF - Swiss Franc`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__czk = () => `Kč - Czech Koruna`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__dkk = () => `kr - Danish Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__eur = () => `€ - Euro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__gbp = () => `£ - British Pound`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__hrk = () => `kn - Croatian Kuna`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__huf = () => `Ft - Hungarian Forint`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__jpy = () => `¥ - Japanese Yen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = () => `kr - Norwegian Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__pln = () => `zł - Polish Zloty`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__sek = () => `kr - Swedish Krona`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__uah = () => `₴ - Ukrainian Hryvnia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__usd = () => `$ - US Dollar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__distance_unit = () => `Distance unit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__ev_toggle = () => `You drive an electric vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__fuel__price = () => `Price per liter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__kwh__price = () => `Price per kWh`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__bike = () => `By bike`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car = () => `By car`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = () => `Recharge when you reach...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = () => `Variables (temperature, wind, number of passengers, etc.) can affect the range of your electric vehicle. Remember to leave a little margin!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__motorcycle = () => `By motorcycle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__walk = () => `On foot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = () => `Your trip parameters`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__traffic_toggle = () => `Avoid traffic jams`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = () => `Your means of transport`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = () => `Your route preferences`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = () => `Miles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__metric = () => `Kilometers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = () => `Search for an itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = () => `Avoided traffic`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__restStop__description = () => `recommends this area for families`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = () => `recommend this stopover village for families`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = () => `Add your vehicle for more accurate cost estimates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = () => `Create your account in just a few clicks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create_account = () => `Create an account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = () => `Fill up on ideas: discover our top destinations and road trips thanks to`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = () => `More information`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = () => `our Newsletter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = () => `Save your route preferences`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = () => `Sign up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_cta_label = () => `Calculate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = () => `Enter a departure and an arrival to see the detailed cost of the itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = () => `The detailed cost of your journeys`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = () => `On ViaMichelin, you can find ...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_cta_label = () => `Visit the Mag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_title = () => `Content to inspire you`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = () => `See points of interest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_cta_label = () => `Discover the selection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_title = () => `All the Michelin selection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = () => `Discover`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = () => `Enter a departure and an arrival to find suggested stopovers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = () => `Ideas for stops along the way`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = () => `Your map appearance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__image_alt = () => `Historical map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__label = () => `Historical`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__image_alt = () => `Hybrid map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__label = () => `Hybrid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = () => `Michelin map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__label = () => `Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__imagex_alt = () => `Scenic roads map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__label = () => `Scenic roads`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__confidentiality_policy = () => `Confidentiality policy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__contact = () => `Contact us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = () => `Cookies`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = () => `Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__legal_notice = () => `Legal notices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__term_of_use = () => `Terms of use`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = () => `We can't find your exact location.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = () => `Your location is disabled`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = () => `Modify your browser settings to authorize access to your location.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = () => `Login failed`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = () => `Login successful`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = () => `Go to my profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = () => `Compass`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = () => `Location`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__login_profile = () => `Login to my profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__profile = () => `Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = () => `Settings`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_in = () => `Zoom in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_out = () => `Zoom out`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = () => `Hotels`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = () => `Find accommodation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__go_to_traffic_info_page__label = () => `Alerts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__low_emission_zone__label = () => `Low emission zone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info__label = () => `Display`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_busy__label = () => `Busy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = () => `Closed lane`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_display_alerts__label = () => `Display alerts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = () => `Fluid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_heavy__label = () => `Heavy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__bookTheFork = () => `TheFork booking widget`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__close = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = () => `ViaMichelin is available in several languages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = () => `Other routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__first = () => `First page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__last = () => `Last page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__nav = () => `Pagination Navigation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__next = () => `Next page`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page = (params) => `Page ${params.page}`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page_active = (params) => `Page ${params.page}, current page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = () => `Previous page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = () => `End of results`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__next = () => `Next`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__previous = () => `Previous`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poiCard__seeDetails = () => `See details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__activities = () => `Activities`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = () => `Step`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__book = () => `Book`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__cancel = () => `Cancel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__details = () => `Details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__itinerary = () => `Itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__actions_book = () => `Book`


/**
 * @param {{ average: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__average_price = (params) => `Approx. ${params.average}`


/**
 * @param {{ price: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (params) => `Booking starting at ${params.price}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = () => `Image carousel for`


/**
 * @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__list_aria_label = (params) => `image ${params.current} on ${params.total}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = () => `See next content`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__prev_button = () => `See previous content`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__many = (params) => `Max ${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__one = (params) => `${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__count_more_than_3_connectors = (params) => `+ ${params.count} more`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__image_alt = () => `Location picture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__michelin = () => `Michelin Guide`


/**
 * @param {{ min: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__min_price = (params) => `Starting from ${params.min}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = () => `Fully booked`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_tag_average = () => `Approx.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_unavailable = () => `Price unavailable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__bad = () => `Bad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__disappointing = () => `Disappointing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__exceptional = () => `Exceptional`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = () => `Fabulous`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__good = () => `Good`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = () => `Mediocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__passable = () => `Passable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__pleasant = () => `Pleasant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = () => `Quite mediocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__superb = () => `Stunning`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = () => `Very good`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__well = () => `Well`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review_count = (params) => `${params.count} reviews`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (params) => `on ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__accommodation = () => `Accommodations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__ev_service = () => `EV stations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__gas_station = () => `Petrol stations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = () => `Car parks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__rest_stop = () => `Rest stops`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = () => `Restaurants`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__tourism = () => `Tourism`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__header = () => `Points of interest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = () => `Points of interest cannot be displayed on this page.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = () => `Show all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__unselect_all = () => `Hide all`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (params) => `Availabilities for ${params.count} nights`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__one__overnight_stay = () => `Availability for 1 night`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability = () => `Dates of your stay`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__error = () => `Information couldn't be displayed.`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__many__other = (params) => `${params.count} others`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__one__other = () => `1 other`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view_more__on_partner_website = () => `Go to Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__with = () => `Availability with`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability_offer = (params) => `Offer ${params.count}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = () => `Back to list`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__carousel__close_button = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__description = () => `About it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__bb = () => `Bed & Breakfast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__camping = () => `Camping`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__hotel = () => `Hotel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__residence = () => `Residence`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__rest = () => `Rest area`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__service = () => `Service area`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__image_alt = () => `Location picture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__location = () => `Location`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = () => `The Michelin Guide's review`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion__tourism = () => `The Michelin Guide's review`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__practical_info = () => `Practical information`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = () => `Discover on GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found = () => `The activities couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_with_region = () => `We couldn't find any activities nearby, but there are plenty of others in the area.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = () => `We couldn't find any activities nearby, but there are plenty of others in the area.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label = () => `Discover on GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = () => `Bib searching on the horizon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__title = () => `You may also like…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_more = () => `See more`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = () => `See on the map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__strong_points = () => `Its strengths`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = () => `Close advanced filters`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = () => `Display prices, star ratings...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__fetch_error = () => `The information couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = () => `Activate a category above to`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__only__michelin = () => `Only the Michelin selection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = () => `display the corresponding filters.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__all = () => `All`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__many = (params) => `${params.count} selected`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__none = () => `No filter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__one = () => `1 selected`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__last_update = (params) => `Max ${params.hours}h`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_count = (params) => `${params.count} and more`


/**
 * @param {{ power: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_power = (params) => `Minimum ${params.power}kW`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__eur = (params) => `${params.amount}€ and more`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__usd = (params) => `$${params.amount} and more`


/**
 * @param {{ minRate: NonNullable<unknown>, maxRate: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_rate = (params) => `Minimum ${params.minRate}/${params.maxRate}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__one = (params) => `${params.count} star and more`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (params) => `${params.count} stars and more`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__none = () => `No filter`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (params) => `${params.amount}€`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__usd = (params) => `$${params.amount}`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__eur = (params) => `${params.minAmount}€ to ${params.maxAmount}€`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (params) => `$${params.minAmount} to $${params.maxAmount}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__stars = (params) => `${params.count} stars`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = () => `Open filters`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (params) => `${params.numberOfFilters} activated filters`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (params) => `${params.numberOfFilters} filter activated`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = () => `To display points of interest (hotels, restaurants, etc.), you need to select at least one category.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = () => `We couldn't find what you're looking for around this location. Try again by expanding your search area.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__filters__toggle_label = () => `Filter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = () => `Pin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = () => `Search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = () => `Sign in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = () => `Logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__favorites__title = () => `Favourite routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = () => `These data are linked to your Michelin account.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = () => `Email address`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__name = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = () => `Password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = () => `Edit on michelin.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__title = () => `Account information`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = () => `You can also modify these parameters when searching for your route.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__title = () => `Trip parameters`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = () => `Your vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = () => `Refresh`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = () => `Year`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__fuel = () => `Fuel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = () => `We regularly update our database. If your vehicle is not listed, choose a similar model or one of our default vehicles.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = () => `Can't find your vehicle?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__motor = () => `Motorization`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = () => `To register your vehicle, you must have a Michelin account.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = () => `Do you have an account?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = () => `To save, you need to fill in all the fields.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = () => `There was an error while saving. Can you try again?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = () => `Your vehicle has been saved.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = () => `Car model and brand`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__vehicle = () => `Vehicle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__dogArea = () => `Canine space`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__nursery = () => `Nursery`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__picnicTable = () => `Picnic table`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__playGround = () => `Playground`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__restaurant = () => `Restaurant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__shop = () => `Store`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restaurantMichelin_greenStarLabel = () => `Sustainable gastronomy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = () => `Road typology`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roadsheet__scenic_roads = () => `Scenic routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__arrival = () => `Arrival`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = () => `Alternative`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = () => `Discovery`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__ecological = () => `Ecological`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__economic = () => `Economic`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__quickest = () => `Quickest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__shortest = () => `Short`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__departure = () => `Departure`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__details = () => `Continue`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__error = () => `The information couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = () => `Arrival at`


/**
 * @param {{ tollCost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (params) => `including ${params.tollCost} for tolls`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (params) => `${params.count} possible itineraries`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__one = (params) => `${params.count} recommended route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = () => `We haven't found any itineraries. Can you modify your search?`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (params) => `${params.count} recharge(s)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = () => `Restriction(s) on this route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__unselected = () => `Anticipated restriction(s) on this route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_cost = () => `Cost`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_distance = () => `Distance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_duration = () => `Duration`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_electricity_consumption = () => `Electricity consumption`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = () => `CO2 emissions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_error_message = () => `Try to modify your search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = () => `Places unknown.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = () => `No itinerary.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__alternative = () => `marker on the alternative route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__default = () => `marker on the route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__discovery = () => `marker on the discovery route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__ecological = () => `marker on the ecological route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__economic = () => `marker on the economic route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__quickest = () => `marker on the quickest route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__shortest = () => `marker on the shortest route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__step = () => `step`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs = () => `Cost`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = () => `Cost details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__electricity = () => `Electricity`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__estimated_for = () => `Cost estimated for`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__fuel = () => `Fuel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls = () => `Tolls`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls_list = () => `Tolls list`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = () => `Total cost of the trip`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__vignette = () => `Vignette`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note = () => `Expense note`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__allowance = () => `Allowance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__arrival = () => `Arrival`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__back = () => `Back to expense note`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__costs = () => `Expenses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = () => `Date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__departure = () => `Departure`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__distance = () => `Distance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = () => `Additional data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = () => `Any other useful information.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = () => `Allowance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance_input = () => `Allowance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__compute_method = () => `Compute method`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__electricity = () => `Electricity price (€/kWh)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__fuel = () => `Fuel price (€/liter)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = () => `Applicant's identity`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity_placeholder = () => `First and last name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = () => `Include the following elements`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__legal_info = () => `Legal information`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__real = () => `Real`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = () => `Edit expense note`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__travel_date = () => `Trip date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__electricity = () => `Electricity`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__fuel = () => `Fuel`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (params) => `Generated on ViaMichelin on ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = () => `Applicant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__notes = () => `Description`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__tolls = () => `Tolls`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__total = () => `Total`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__travel = () => `Details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__vignette = () => `Vignettes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions = () => `Instructions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = () => `The navigation instructions couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way = () => `On the way`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = () => `On the way`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = () => `Corresponds to the distance between your journey and the proposed points of interest.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__scope = () => `Search scope`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__up_to = (params) => `Up to ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = () => `To discover`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = () => `Carpool`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__description = () => `Average amount recorded`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__subtitle = () => `with`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__title = () => `Save €60`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__button_label = () => `Detailed costs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__ev_charging = () => `Energy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = () => `Fuel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__title = () => `Cost of this trip`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__tolls = () => `Tolls`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__on_the_road__title = () => `On the way`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__rest_stop__button_label = () => `Ideas for stopovers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__button_label = () => `Roadmap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__emissions = () => `Emissions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__ev_charging = () => `Refills`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = () => `Fast lanes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = () => `Roadmap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = () => `See accommodations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = () => `Accommodation on arrival`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_label = () => ``


/**
 * @param {{ device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_url = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__description = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__legal_notice = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = () => ``


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown>, device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_url = (params) => ``


/**
 * @param {{ cost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__description = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__legal_notice = () => ``


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = () => `Where are we going?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__aria_label = () => `Itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = () => `Itinerary`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = () => `No results found`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = () => `An error occurred.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__image_alt = () => `Bib looking`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__results__aria_label = () => `Search results`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const settings__close = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__close_button = () => `Close`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = () => `Disconnecting...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = () => `You've been disconnected`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const soon = () => `Coming soon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_deviation__cta = () => `Ignore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_accident = () => `Accident`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_dangerous = () => `Road closed`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = () => `Incident`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__construction_cone = () => `Work`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = () => `Shrinkage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__weather_hail = () => `Weather`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = () => `TRAFFIC CONDITIONS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__go_to_partner_website = () => `Go to Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = () => `No room available`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = () => `We haven't found much accommodation that match your search. For more choice, go to`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on_partner_website = () => `Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = () => `Only with EV stations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = () => `Search scope`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__text = () => `Corresponds to the distance between your journey and the proposed points of interest.`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (params) => `Up to ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = () => `See more`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = () => `Our recommendations for accommodation, restaurants...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = () => `Points of interest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = () => `Stopover ideas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = () => `Accommodations are available in your arrival area.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = () => `See on the map`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = () => `Points of interest couldn't be displayed.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = () => `Area of interest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__see_on_map = () => `See on the map`
